import User from '@/models/User'
import * as MutationTypes from '../mutation-types'
import axios from 'axios'
import router from '../../router/index'
import { Notification } from 'element-ui'
import config from '../../config.js'
import dictionary from '../../store/dictionary'

const state = {
  // user: User.from(sessionStorage.token)
  userFirstname: '',
  userSurname: '',
  user: null,
  loadingUserScope: false,
  userScope: null,
  userScopeGr: null,
  activeRole: null,
  mfaCredentials: null
}

const mutations = {
  [MutationTypes.CHANGEDROLE] (...all) {
    state.activeRole = all[1].role
    state.user.activeRole = all[1].role
    all[1].rootState.showWorkingApplication = false
    all[1].rootState.activeLane = ''
    all[1].rootState.searchedAppHistory = []
    all[1].rootState.assignedApplications = []
    all[1].rootState.workingApplication = {}
    all[1].rootState.showWorkingApplication = false
    all[1].rootState.searchedApps = []
    all[1].rootState.searchVisible = false
    all[1].rootState.searchUniVisible = false
    all[1].rootState.consultantsListVisible = false
    all[1].rootState.phdRegistrationVisible = false
    router.replace(`/${all[1].role}`)
  },
  [MutationTypes.UPDATEPROFILE] (state, data) {
    state.user = data
    state.loadingUserScope = false
  },
  [MutationTypes.SELECTEDROLE] (...all) {
    state.activeRole = all[1].role
    all[1].rootState.showWorkingApplication = false
    all[1].rootState.activeLane = ''
    all[1].rootState.searchedAppHistory = []
    all[1].rootState.assignedApplications = []
    all[1].rootState.workingApplication = {}
    all[1].rootState.showWorkingApplication = false
    state.user = {
      id: all[1].state.user.id,
      name: all[1].state.user.name,
      email: all[1].state.user.email,
      roles: all[1].state.userScope,
      activeRole: all[1].role
    }
    router.replace(`/${all[1].role}`)
  },
  [MutationTypes.LOGIN] (...all) {
    const data = all[1].user
    state.user = User.from(data.access_token)
    state.user.firstname = data.user.firstname
    state.user.name = data.user.name
    state.user.surname = data.user.surname
    state.userFirstname = data.user.firstname
    state.userSurname = data.user.surname
    state.user.email = data.user.email
    state.userScope = state.user.scopes
    state.userScopeGr = state.user.scopes.map(role => dictionary[role])
    state.loadingUserScope = false
    state.mfaCredentials = null
    all[1].rootState.startTimer = true
  },
  // [MutationTypes.REFRESHED] (...all) {
  //   let data = all[1].user
  //   state.user = User.from(data.access_token)
  //   state.user.firstname = data.user.firstname
  //   state.user.name = data.user.name
  //   state.user.surname = data.user.surname
  //   state.userFirstname = data.user.firstname
  //   state.userSurname = data.user.surname
  //   state.user.email = data.user.email
  //   state.userScope = state.user.scopes
  //   state.userScopeGr = state.user.scopes.map(role => dictionary[role])
  //   state.loadingUserScope = false
  //   all[1].rootState.startTimer = true
  // },
  // Stores temporary credentials (name + password) between the first loginMFA
  // call and the OTP verification step. Cleared on successful login or logout.
  [MutationTypes.SET_MFA_CREDENTIALS] (state, data) {
    state.mfaCredentials = data
  },
  [MutationTypes.CLEAR_MFA_CREDENTIALS] (state) {
    state.mfaCredentials = null
  },
  [MutationTypes.LOGOUT] (...all) {
    state.user = null
    state.userScope = null
    state.userScopeGr = null
    state.currentUser = null
    state.activeRole = null
    state.mfaCredentials = null
    delete sessionStorage.token
    state.loadingUserScope = false
    // remove all assigned and working apps
    all[1].rootState.showWorkingApplication = false
    all[1].rootState.activeLane = ''
    all[1].rootState.searchedAppHistory = []
    all[1].rootState.assignedApplications = []
    all[1].rootState.workingApplication = {}
    all[1].rootState.showWorkingApplication = false
    all[1].rootState.startTimer = false
    all[1].rootState.searchedApps = []
    all[1].rootState.searchVisible = false
    all[1].rootState.searchUniVisible = false
    all[1].rootState.consultantsListVisible = false
    all[1].rootState.phdRegistrationVisible = false
    router.replace('/login')
  }
}

const getters = {
  userNameSurname (state) {
    return state.activeRole != null ? `${state.userFirstname} ${state.userSurname}` : ''
  },
  currentUser (state) {
    return state.activeRole != null ? state.user : null
  },
  isAdmin (state) {
    return state.user && state.user.roles.find(role => role === 'Admin')
  },
  userScope (state) {
    return state.userScope
  },
  userScopeGr (state) {
    return state.userScopeGr
  },
  loadingUserScope (state) {
    return state.loadingUserScope
  },
  activeRole (state) {
    return state.activeRole
  },
  mfaCredentials (state) {
    return state.mfaCredentials
  }
}

// Accepts the full response.data envelope so that top-level metadata
// (success, message, timestamp) is available alongside the OTP-specific fields.
// The inner payload is expected at response.data.data.
function normalizeMfaResponse (apiResponse) {
  const envelope = apiResponse || {}
  const data = envelope.data || {}
  const original = data.original || {}

  // Direct login: access_token present means no OTP required for this role
  if (data.access_token) {
    return {
      success: envelope.success === true,
      otpActive: false,
      otpRequired: false,
      directLogin: true,
      userData: data,
      raw: envelope
    }
  }

  // ok === true  → OTP was just created
  // ok === false inside original → OTP already active (resend too soon)
  const isCreated = data.ok === true
  const isAlreadyActive = original.ok === false
  const otpExpiresAt = data.expires_at || original.expires_at || null

  let otpCountdownSeconds = 0
  if (typeof data.expires_in_seconds === 'number') {
    otpCountdownSeconds = data.expires_in_seconds
  } else if (typeof original.retry_after_seconds === 'number') {
    otpCountdownSeconds = original.retry_after_seconds
  }

  return {
    success: envelope.success === true,
    apiSuccess: envelope.success === true,
    apiTimestamp: envelope.timestamp || null,
    apiMessage: envelope.message || null,
    otpActive: isCreated || isAlreadyActive,
    otpRequired: true,
    directLogin: false,
    otpJustCreated: isCreated,
    otpExpiresAt,
    otpCountdownSeconds,
    emailMasked: data.email_masked || original.email_masked || null,
    raw: envelope
  }
}

const actions = {
  updateProfile ({ state, commit, rootState }) {
    state.loadingUserScope = true
    router.replace('/profile')
    axios.get(`${config.BASE_URL}/users/${state.user.id}`).then((response) => {
      commit(MutationTypes.UPDATEPROFILE, response.data.data)
    })
  },
  newRole ({ state, commit, rootState }, role) {
    commit(MutationTypes.CHANGEDROLE, { state, role, rootState })
  },
  selectedRole ({ state, commit, rootState }, role) {
    if (role === 'TemporaryUser') {
      Notification.warning({
        title: 'Ειδοποίηση',
        message: 'Παρακαλώ μεταβείτε στο λογαριασμό σας πάνω δεξιά στην επιλογή προφίλ για να αλλάξετε τον κωδικό πρόσβασης σας και να συμπληρώσετε τα στοιχεία σας.',
        offset: 100,
        duration: -1
      })
    }
    commit(MutationTypes.SELECTEDROLE, { state, role, rootState })
  },
  refresh ({ state, commit, rootState }) {
    axios.post(`${config.BASE_URL}/login/refresh`, {}).then((response) => {
      if (!response.data.data.access_token) {
        this.error = 'Refresh failed!'
        commit(MutationTypes.LOGOUT, { state, commit, rootState })
        return
      }
      sessionStorage.token = response.data.data.access_token
      // this.error = false
      // commit(MutationTypes.REFRESHED, response.data.data)
    }).catch(() => {
      this.error = 'Refresh failed!'
      commit(MutationTypes.LOGOUT, { state, commit, rootState })
    })
  },
  login ({ state, commit, rootState }, { name, password }) {
    if (name !== '' && password !== '') {
      state.loadingUserScope = true
      axios.post(
        `${config.BASE_URL}/login`,
        { name, password },
        { headers: { 'Content-type': 'application/json' } }
      ).then((response) => {
        if (response.data.data.scope[0] === 'TemporaryUser') {
          Notification.warning({
            title: 'Ειδοποίηση',
            message: 'Παρακαλώ επιλέξτε τον προσωρινό ρόλο.',
            offset: 100,
            duration: 3000
          })
        }
        if (!response.data.data.access_token) {
          this.error = 'Login failed!'
          commit(MutationTypes.LOGOUT, { state, commit, rootState })
          return
        }
        sessionStorage.token = response.data.data.access_token
        this.error = false
        // add if to bypass role selection if there is only one role in scope
        // if (User.from(response.data.data.access_token).scopes.length === 1) {
        //   this.$store.commit(MutationTypes.SELECTEDROLE, User.from(response.data.data.access_token).scopes[0])
        // } else {
        const user = response.data.data
        commit(MutationTypes.LOGIN, { state, user, rootState })
        // }
      }).catch((error) => {
        let title
        let message
        if (error.response.status === 423) {
          title = 'Κλείδωμα λογαριασμού'
          message = 'Δοκιμάστε ξανά σε 5 λεπτά'
        } else {
          title = 'Λάθος Στοιχεία!'
          message = 'Δεν επιτρέπεται η είσοδος'
        }
        // this.error = 'Login failed!'
        state.loadingUserScope = false
        // alert('asdcsdc')
        Notification.error({ title, message, duration: 3000 })
        commit(MutationTypes.LOGOUT, { state, commit, rootState })
      })
    }
  },
  // Step 1 of MFA login: validates credentials and triggers OTP dispatch.
  // On success the component transitions to the OTP step.
  // On 423 the account is locked; on 429 the login service is temporarily rate-limited;
  // on other errors credentials are wrong.
  // If access_token is returned directly, the role has no OTP requirement.
  loginMFA ({ state, commit, rootState }, { name, password }) {
    if (name === '' || password === '') {
      return Promise.resolve({ success: false })
    }
    state.loadingUserScope = true
    return axios.post(
      `${config.BASE_URL}/loginMFA`,
      { name, password },
      { headers: { 'Content-type': 'application/json' } }
    ).then((response) => {
      const normalized = normalizeMfaResponse(response.data)
      // Direct login: no OTP required for this role
      if (normalized.directLogin) {
        sessionStorage.token = normalized.userData.access_token
        commit(MutationTypes.LOGIN, { state, user: normalized.userData, rootState })
        state.loadingUserScope = false
        return normalized
      }
      commit(MutationTypes.SET_MFA_CREDENTIALS, { name, password })
      state.loadingUserScope = false
      if (normalized.otpJustCreated) {
        Notification.success({
          title: 'Επιτυχία',
          message: 'Στάλθηκε κωδικός OTP στο email σας.',
          duration: 3000
        })
      }
      return normalized
    }).catch((error) => {
      let title
      let message
      if (error.response && error.response.status === 423) {
        title = 'Κλείδωμα λογαριασμού'
        message = 'Δοκιμάστε ξανά σε 5 λεπτά'
      } else if (error.response && error.response.status === 429) {
        title = 'Προσωρινός περιορισμός σύνδεσης'
        message = 'Παρακαλώ, δοκιμάστε ξανά σε λίγο.'
      } else {
        title = 'Λάθος Στοιχεία!'
        message = 'Δεν επιτρέπεται η είσοδος'
      }
      state.loadingUserScope = false
      commit(MutationTypes.CLEAR_MFA_CREDENTIALS)
      Notification.error({ title, message, duration: 5000 })
      return { success: false }
    })
  },
  // Step 2 of MFA login: submits the OTP along with the stored credentials.
  // Uses the same /loginMFA endpoint with the additional otp field.
  // Clears stored credentials after successful or locked-account response.
  verifyLoginMFA ({ state, commit, rootState }, { otp }) {
    if (state.mfaCredentials && state.mfaCredentials.name !== '' && state.mfaCredentials.password !== '' && otp !== '') {
      state.loadingUserScope = true
      return axios.post(
        `${config.BASE_URL}/loginMFA`,
        {
          name: state.mfaCredentials.name,
          password: state.mfaCredentials.password,
          otp
        },
        { headers: { 'Content-type': 'application/json' } }
      ).then((response) => {
        if (response.data.data.scope[0] === 'TemporaryUser') {
          Notification.warning({
            title: 'Ειδοποίηση',
            message: 'Παρακαλώ επιλέξτε τον προσωρινό ρόλο.',
            offset: 100,
            duration: 3000
          })
        }
        if (!response.data.data.access_token) {
          this.error = 'Login failed!'
          state.loadingUserScope = false
          commit(MutationTypes.CLEAR_MFA_CREDENTIALS)
          return { success: false }
        }
        sessionStorage.token = response.data.data.access_token
        this.error = false
        const user = response.data.data
        commit(MutationTypes.LOGIN, { state, user, rootState })
        return { success: true }
      }).catch((error) => {
        let title
        let message
        if (error.response && error.response.status === 423) {
          title = 'Κλείδωμα λογαριασμού'
          message = 'Δοκιμάστε ξανά σε 5 λεπτά'
          commit(MutationTypes.CLEAR_MFA_CREDENTIALS)
        } else {
          title = 'Λάθος OTP!'
          message = 'Ο κωδικός είναι λανθασμένος ή έχει λήξει'
        }
        state.loadingUserScope = false
        Notification.error({ title, message, duration: 3000 })
        return { success: false }
      })
    }
    return Promise.resolve({ success: false })
  },
  clearLoginMFA ({ commit }) {
    commit(MutationTypes.CLEAR_MFA_CREDENTIALS)
  },
  logout ({ state, commit, rootState }) {
    return axios.post(`${config.BASE_URL}/logout`, {}).then((response) => {
      // if (!response.data.access_token) {
      //   this.error = 'Logout failed!'
      //   return
      // }
      this.error = false
      commit(MutationTypes.LOGOUT, { state, response, rootState })
      // commit(MutationTypes.CHANGEDROLE, { state, role, rootState })
    })
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js